import { attr } from '@ember-data/model';
import EmberDataBaseFragment from '@square/dashboard-data/models/ember-data-base-fragment';
export default EmberDataBaseFragment.extend({
  autoApplyTaxes: attr('boolean')
}).reopenClass({
  _modelNameForMigration: 'pricing-options'
});